import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewprojectdetails-questionnaire',
  templateUrl: './viewprojectdetails-questionnaire.component.html',
  styleUrls: ['./viewprojectdetails-questionnaire.component.css']
})
export class ViewprojectdetailsQuestionnaireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/project/viewprojectdetails-questionnaire/viewprojectdetails-questionnaire.component.ts